module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-resort.ddb2016e.jpg";